import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';

const B2CSalesList = lazy(() =>
    import('../../pages/B2CManagement/Sales').then((module) => ({
        default: module.SalesList,
    }))
);
const SalesDetails = lazy(() =>
    import('../../pages/B2CManagement/Sales/Sales.Details').then((module) => ({
        default: module.SalesDetails,
    }))
);
export function B2CSalesContainer() {
    return (
        <Routes>
            <Route path="details/:codeId/:type" element={<SalesDetails />} />
            <Route
                path={'*'}
                element={
                    <LazyLoadComponent
                        type="LIST"
                        Component={<B2CSalesList />}
                    />
                }
            />
        </Routes>
    );
}
